import { z } from 'zod';

export const getNumberInputValidationSchema = ({ min, max, optional }) => {
  let schema = z.coerce.number();
  if (min) {
    const { value, message = `Value must be at least ${min.value}` } = min;
    schema = schema.min(value, { message });
  }
  if (max) {
    const { value, message = `Value must be no more than ${max.value}` } = max;
    schema = schema.max(value, { message });
  }

  if (!optional) {
    return schema;
  }

  const finalSchema = z.preprocess(
    (val) => (val === '' ? undefined : val),
    schema.optional(),
  );

  return finalSchema;
};
